import { TextInput } from "artisn-ui-react";
import React from "react";

import Styles from "./SearchBillingData.styles";
import { SearchBillingDataProps as Props } from "./SearchBillingData.types";
import useI18n from "hooks/useI18n";

import SearchSVG from "../../../../public/assets/images/search.svg";

const SearchBillingData: React.FC<Props> = props => {
  const t = useI18n();
  const { setSearchResult, isDisabled } = props;

  return (
    <Styles className="SearchBillingData">
      <div className="SearchBillingData__search-bar">
        <div className="SearchBillingData__icon">
          <SearchSVG className />
        </div>
        <TextInput
          className="SearchBillingData__text-input"
          name="search-bar"
          disabled={isDisabled}
          onChange={e => setSearchResult?.(e.target.value.trim())}
          maxLength={50}
          placeholder={t.billing.searchBillingInformation}
          autoComplete="off"
        />
      </div>
    </Styles>
  );
};

SearchBillingData.defaultProps = {};

export default SearchBillingData;
